import { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import DiscussionRoom from './components/DiscussionRoom';
import { getCourseById } from '../../api/apiServices';

export default function CourseDiscussionPage() {
  const { courseId } = useParams();
  const [course, setCourse] = useState(null);

  useEffect(() => {
    getCourseById(courseId)
      .then((res) => { if (res?.success && res.course) setCourse(res.course); })
      .catch((err) => console.error('Failed to load course', err));
  }, [courseId]);

  return (
    <div className="min-h-screen bg-slate-50">
      <Navbar />
      <div className="pt-20 pb-10 px-4">
        <div className="max-w-3xl mx-auto">
          <Link
            to={`/courses/${courseId}`}
            className="inline-flex items-center gap-1.5 text-xs font-semibold text-slate-500 hover:text-teal-600 mb-4"
          >
            <i className="ri-arrow-left-line" /> Back to course
          </Link>
          <div className="flex items-center gap-2 mb-4">
            <i className="ri-group-line text-teal-600 text-lg" />
            <h1 className="text-lg font-bold text-slate-900">
              {course ? `${course.title} -- Discussion` : 'Course Discussion'}
            </h1>
          </div>

          <DiscussionRoom courseId={courseId} />
        </div>
      </div>
      <Footer />
    </div>
  );
}
